import CONST from "../config/CONST";

let doLogTable = false;
let doLogInfo = false;
let doLogErr = false;
let doLogWarn = false;

function getUrlParameter(name) {
    // eslint-disable-next-line
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export const setLog = (debug) => {
    if(getUrlParameter("debug") === "debug") {
        window[CONST.JS_NAMESPACE+"_debug"] = true;
    }

    doLogTable = true; //window[CONST.JS_NAMESPACE+"_debug"] === true && window.console && typeof console.table === 'function';
    doLogInfo = true; //window[CONST.JS_NAMESPACE+"_debug"] === true && window.console && typeof console.table === 'function';
    doLogErr = true; //window[CONST.JS_NAMESPACE+"_debug"] === true && window.console && typeof console.log === 'function';
    doLogWarn = true; //window[CONST.JS_NAMESPACE+"_debug"] === true && window.console && typeof console.log === 'function';

    // doLogTable = window.console && typeof console.table === 'function';
    // doLogInfo = window.console && typeof console.log === 'function';
    // doLogErr = window.console && typeof console.log === 'function';
    // doLogWarn = window.console && typeof console.log === 'function';
}

export const log = (...args) => {
    if (doLogInfo) {
        console.log('%c['+CONST.JS_NAMESPACE+']', 'background-color: #597ddb; color: #fff; padding: 5px; font-weight: bold', ...args);
    }
};
export const logInfo = (...args) => {
    log(...args)
};

export const logTable = (msg, obj) => {
    if (doLogInfo) {
        console.log('%c['+CONST.JS_NAMESPACE+']', 'background-color: #597ddb; color: #fff; padding: 5px; font-weight: bold', msg);
    }
    if (doLogTable) {
        console.table(obj);
    }
};
export const logErr = (...args) => {
    if (doLogErr) {
        console.log('%c['+CONST.JS_NAMESPACE+']', 'background-color: #d93029; color: #fff; padding: 5px; font-weight: bold', ...args);
    }
};
export const logWarn = (...args) => {
    if (doLogWarn) {
        console.log('%c['+CONST.JS_NAMESPACE+']', 'background-color: #ffba02; color: #fff; padding: 5px; font-weight: bold', ...args);
    }
};


